var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Eae men "+_vm._s(_vm.nome))]),_c('a',{attrs:{"href":"#"},on:{"click":_vm.myFunction}},[_vm._v(" Ir para AKBANK")])])}
var staticRenderFns = []

export { render, staticRenderFns }